import HexAuthWrapper from "../../components/HexAuthWrapper";
import { CartSummary } from "../../containers/Order";

const ShoppingCartSummaryPage = () => {
  return (
    <div>
      <HexAuthWrapper>
        <CartSummary />
      </HexAuthWrapper>
    </div>
  );
};

export default ShoppingCartSummaryPage;
